import { render } from "./InstanceDataPopup.vue?vue&type=template&id=197086bc&scoped=true"
import script from "./InstanceDataPopup.vue?vue&type=script&lang=js"
export * from "./InstanceDataPopup.vue?vue&type=script&lang=js"

import "./InstanceDataPopup.vue?vue&type=style&index=0&id=197086bc&lang=scss&scoped=true"

import exportComponent from "/home/forge/deployments/control-center.conneqt.io/new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197086bc"]])

export default __exports__